import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  doc,
  getDoc
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import QRCode from "qrcode";

export default function ConsultaCadastro() {

  const navigate = useNavigate();
  const functions = getFunctions(undefined, "southamerica-east1");

  // ===== ESTADOS =====
  const [cpf, setCpf] = useState("");
  const [eventoId, setEventoId] = useState("");
  const [eventos, setEventos] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState("");
  const [resultadoParaImpressao, setResultadoParaImpressao] = useState(null);
  const [statusConsulta, setStatusConsulta] = useState("idle");
  const [erro, setErro] = useState("");

  // Controle
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const [role, setRole] = useState("");

  // loading consulta
  const [loadingConsulta, setLoadingConsulta] = useState(false);

  // ===== FORMATADOR CPF =====
  const formatCpf = (value) =>
    value
      .replace(/\D/g, "")
      .slice(0, 11)
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");


  useEffect(() => {
    const loadEventos = async () => {
      try {
        const snap = await getDocs(collection(db, "events"));

        const lista = snap.docs.map((d) => {
          const data = d.data();
          return {
            id: d.id,
            nome: data.nome || "Sem nome",
          };
        });

        setEventos(lista);

        if (lista.length > 0) {
          setEventoSelecionado(lista[0].id);
          setEventoId(lista[0].id);
        }
      } catch (err) {
        console.error("Erro ao carregar eventos", err);
      }
    };

    loadEventos();
  }, []);
  // ===== VERIFICA ADMIN =====
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const idTokenResult = await user.getIdTokenResult(true);

        const claims = idTokenResult.claims;

        setIsAdmin(!!claims.admin);

        setRole(claims.role || "");

            if (claims.role === "master") {

        const snap = await getDocs(collection(db, "events"));

        const lista = snap.docs.map((d) => ({
          id: d.id,
          nome: d.data().nome || "Sem nome",
        }));

        setEventos(lista);

        if (lista.length > 0) {
          setEventoSelecionado(lista[0].id);
          setEventoId(lista[0].id);
        }

      } else {

        const eventoRef = doc(db, "events", claims.eventoId);

        const eventoSnap = await getDoc(eventoRef);

        if (eventoSnap.exists()) {

          const evento = {
            id: eventoSnap.id,
            nome: eventoSnap.data().nome || "Sem nome",
          };

          setEventos([evento]);

          setEventoSelecionado(evento.id);

          setEventoId(evento.id);

        }

      }
      } catch (error) {
        console.error("Erro ao verificar admin:", error);
        setIsAdmin(false);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // ===== CONSULTA CPF =====
const consultar = async (e) => {
  e.preventDefault();

  if (loadingConsulta) return;

  setErro("");
  setStatusConsulta("idle");
  setResultadoParaImpressao(null);
  setLoadingConsulta(true);

  try {
    const eventoFinal = eventoSelecionado || eventoId;

    const user = auth.currentUser;

    if (!user) {
      throw new Error("Usuário não autenticado");
    }

    if (!eventoFinal) {
      throw new Error("Informe o evento.");
    }

    const cpfLimpo = cpf.replace(/\D/g, "");

    if (!cpfLimpo || cpfLimpo.length !== 11) {
      throw new Error("CPF inválido");
    }

    const fn = httpsCallable(functions, "consultarCpf");

    const res = await fn({
      cpf: cpfLimpo,
      eventoId: eventoFinal,
    });

    const data = res.data;

    if (!data?.found) {
      setStatusConsulta("nao-encontrado");
      return;
    }

    setResultadoParaImpressao({
      ...data.data,
      tipo: data.tipo === "visitante" ? "Visitante" : "Expositor",
    });

    setStatusConsulta("encontrado");

  } catch (err) {
    console.error(err);
    setErro(err.message || "Erro ao consultar CPF");
  } finally {
    setLoadingConsulta(false);
  }
};

 // ===== IMPRIMIR =====

async function imprimirResultado(res) {
  if (!res) return;

  if (!res.codigo) {
    alert(
      "Este cadastro não possui código de credencial. Verifique o cadastro antes de imprimir."
    );
    return;
  }

  let printWindow = null;

  try {
    // Gera o QR Code contendo somente o código da credencial.
    const qrCodeDataUrl = await QRCode.toDataURL(res.codigo, {
      errorCorrectionLevel: "M",
      margin: 2,
      width: 400,
      color: {
        dark: "#000000",
        light: "#FFFFFF",
      },
    });

    // Protege os dados inseridos no HTML.
    const escaparHTML = (valor) =>
      String(valor || "").replace(/[&<>"']/g, (caractere) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[caractere]);

    const nomeCompleto = (res.nome || "").trim();
    const partesNome = nomeCompleto.split(/\s+/).filter(Boolean);

    const primeiroNome = escaparHTML(partesNome[0] || "");
    const sobrenome = escaparHTML(
      partesNome.length > 1
        ? partesNome[partesNome.length - 1]
        : ""
    );

    const tipo =
      res.tipo === "Expositor" ? "EXPOSITOR" : "VISITANTE";

    const ehVisitante = tipo === "VISITANTE";

    const empresa = escaparHTML(res.empresa || "");

    // Monta o conteúdo específico de cada tipo de credencial.
    const identificacao =
      tipo === "VISITANTE"
        ? `<div class="tipo">VISITANTE</div>`
        : empresa
          ? `<div class="empresa">${empresa}</div>`
          : "";

    // Visitante não terá sobrenome na etiqueta.
    const informacoesEtiqueta = ehVisitante
      ? `
          <div class="primeiro-nome">${primeiroNome}</div>
          ${identificacao}
        `
      : `
          <div class="primeiro-nome">${primeiroNome}</div>
          <div class="sobrenome">${sobrenome}</div>
          ${identificacao}
        `;

    const htmlEtiqueta = `
      <!DOCTYPE html>
      <html lang="pt-BR">
      <head>
        <meta charset="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <title>Imprimir etiqueta</title>

        <style>
          @page {
            size: 80mm 30mm;
            margin: 0;
          }

          * {
            box-sizing: border-box;
          }

          html,
          body {
            width: 80mm;
            height: 30mm;
            margin: 0;
            padding: 0;
            font-family: Arial, Helvetica, sans-serif;
            background: #fff;
            color: #000;
          }

          body {
            overflow: hidden;
          }

          .etiqueta {
            width: 80mm;
            height: 30mm;
            padding: 2mm;
            display: flex;
            align-items: stretch;
            gap: 2mm;
            overflow: hidden;
            background: #fff;
            color: #000;
          }

          .informacoes {
            width: 50mm;
            height: 26mm;
            flex: 0 0 50mm;
            min-width: 0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            padding-top: 1mm;
            overflow: hidden;
            position: relative;
          }

          .primeiro-nome {
            display: block;
            width: 100%;
            max-width: 100%;
            margin: 0;
            font-size: ${ehVisitante ? "24pt" : "30pt"};
            line-height: 1;
            font-weight: 900;
            letter-spacing: -0.7px;
            white-space: nowrap;
            overflow: hidden;
          }

          .sobrenome {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 1mm;
            font-size: 14pt;
            line-height: 1.05;
            font-weight: 400;
            overflow-wrap: anywhere;
            word-break: normal;
          }

          .tipo {
            margin-top: auto;
            padding-bottom: 0;
            font-size: 20pt;
            line-height: 1;
            font-weight: 400;
            white-space: nowrap;
          }

          .empresa {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: auto;
            font-size: 12pt;
            line-height: 1.1;
            font-weight: 700;
            white-space: nowrap;
            overflow: hidden;
          }

          /* QR Code fixo à direita */

          .area-qr {
            width: 24mm;
            height: 26mm;
            flex: 0 0 24mm;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .qr {
            display: block;
            width: 23mm;
            height: 23mm;
            object-fit: contain;
            image-rendering: pixelated;
          }

          @media screen {
            body {
              outline: 1px solid #ccc;
            }
          }

          @media print {
            html,
            body {
              width: 80mm;
              height: 30mm;
              overflow: hidden;
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }

            .etiqueta {
              break-inside: avoid;
              page-break-inside: avoid;
            }
          }
        </style>
      </head>

      <body>
        <div class="etiqueta">
          <div class="informacoes">
            ${informacoesEtiqueta}
          </div>

          <div class="area-qr">
            <img
              class="qr"
              src="${qrCodeDataUrl}"
              alt="QR Code da credencial"
            />
          </div>
        </div>

        <script>
          window.addEventListener("load", function () {
            const primeiroNome =
              document.querySelector(".primeiro-nome");

            const sobrenome =
              document.querySelector(".sobrenome");

            const empresa =
              document.querySelector(".empresa");

            // Reduz o tamanho do texto até caber na largura disponível.
            function ajustarTexto(elemento, tamanhoInicial, tamanhoMinimo) {
              if (!elemento) return;

              let tamanho = tamanhoInicial;

              elemento.style.fontSize = tamanho + "pt";

              while (
                elemento.scrollWidth > elemento.clientWidth &&
                tamanho > tamanhoMinimo
              ) {
                tamanho -= 1;
                elemento.style.fontSize = tamanho + "pt";
              }
            }

            ajustarTexto(
              primeiroNome,
              ${ehVisitante ? 24 : 28},
              6
            );

            ajustarTexto(sobrenome, 14, 6);
            ajustarTexto(empresa, 12, 5);

            const qr = document.querySelector(".qr");

            function abrirImpressao() {
              window.focus();

              window.setTimeout(function () {
                window.print();
              }, 400);
            }

            // Garante que o QR Code esteja pronto antes de imprimir.
            if (qr.complete && qr.naturalWidth > 0) {
              abrirImpressao();
            } else {
              qr.addEventListener("load", abrirImpressao, {
                once: true,
              });

              qr.addEventListener(
                "error",
                function () {
                  alert("Não foi possível carregar o QR Code.");
                },
                { once: true }
              );
            }
          });
        </script>
      </body>
      </html>
    `;

    // Abre uma janela exclusiva para a etiqueta.
    printWindow = window.open(
      "",
      "_blank",
      "width=600,height=500"
    );

    if (!printWindow) {
      alert(
        "O navegador bloqueou a janela de impressão. Permita pop-ups para este site e tente novamente."
      );
      return;
    }

    printWindow.document.open();
    printWindow.document.write(htmlEtiqueta);
    printWindow.document.close();

  } catch (error) {
    console.error("Erro ao gerar etiqueta:", error);

    if (printWindow && !printWindow.closed) {
      printWindow.close();
    }

    alert("Não foi possível gerar a etiqueta para impressão.");
  }
}
  useEffect(() => {
    const afterPrint = () => setResultadoParaImpressao(null);
    window.addEventListener("afterprint", afterPrint);
    return () => window.removeEventListener("afterprint", afterPrint);
  }, []);

  // ===== LOADING =====
  if (loading) return <p>Carregando...</p>;

  // ===== BLOQUEIO ADMIN =====
  if (!isAdmin) {
    return (
      <div className="page">
        <div className="card-cadastro">
          <h1>🔒 Acesso restrito</h1>
          <p>Somente administradores podem acessar esta página.</p>
        </div>
      </div>
    );
  }

  // ===== UI =====
  return (
    <div
      className="page-bg"
      style={{ backgroundImage: 'url("/imagens/FundoGeral.png")' }}
    >
      <div className="card-cadastro-admin">
        <div className="card-cadastro">
          <h2>Insira seu CPF</h2>

        <select
            value={eventoSelecionado}
            onChange={(e) => setEventoSelecionado(e.target.value)}
            disabled={loadingConsulta || role !== "master"}
            style={{ fontSize: "18px", padding: "10px" }}
          >
            {eventos.map((ev) => (
              <option key={ev.id} value={ev.id}>
                {ev.nome}
              </option>
            ))}
          </select>

          <form onSubmit={consultar}>
            <input
              placeholder="Digite o CPF"
              value={cpf}
              onChange={(e) => setCpf(formatCpf(e.target.value))}
              disabled={loadingConsulta}
            />
            <button disabled={loadingConsulta}>
              {loadingConsulta ? "Consultando..." : "Consultar"}
            </button>
          </form>

                  {statusConsulta === "encontrado" && resultadoParaImpressao && (
          <div
            style={{
              marginTop: 16,
              padding: "16px",
              background: "#1f2430",
              borderRadius: "10px",
              border: "1px solid #3b82f6",
              color: "#ffffff",
              textAlign: "left",
            }}
          >
            <h3
              style={{
                marginTop: 0,
                marginBottom: 12,
                color: "#3b82f6",
                textAlign: "center",
              }}
            >
              Cadastro encontrado
            </h3>

            <p>
              <strong>Nome:</strong> {resultadoParaImpressao.nome}
            </p>

            <p>
              <strong>Tipo:</strong> {resultadoParaImpressao.tipo}
            </p>

            {eventoSelecionado === "EntreNos" && (
              <p>
                <strong>Interesse comercial:</strong>{" "}
                {resultadoParaImpressao.interesseComercial === "sim"
                  ? "Sim"
                  : resultadoParaImpressao.interesseComercial === "nao"
                    ? "Não"
                    : "Não informado"}
              </p>
            )}

            <button
              style={{
                width: "100%",
                marginTop: 12,
              }}
              onClick={async () => {
                await imprimirResultado(resultadoParaImpressao);
                setResultadoParaImpressao(null);
                setStatusConsulta("idle");
              }}
            >
              🖨️ Imprimir etiqueta
            </button>
          </div>
        )}

          {statusConsulta === "nao-encontrado" && (
            <p style={{ marginTop: 16, color: "red" }}>
              Cadastro não encontrado.
            </p>
          )}

          {erro && <p style={{ color: "red" }}>{erro}</p>}
        </div>

        {role !== "totem" && (
          <button
            style={{ marginTop: 16 }}
            onClick={() => navigate("/eventos-ativos")}
          >
            Cadastrar-se
          </button>
        )}
      </div>

      {loadingConsulta && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Consultando cadastro...</p>
        </div>
      )}
    </div>
  );
}